import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

/**
 * Emits when the user clicks the verify-vehicle CTA (e.g. in Prismic HTML).
 * The CTA is matched by data-action="RENDER_CTA" or class "verify-vehicle-cta-trigger".
 * Page components that own the verify vehicle modal subscribe and call openModal(null).
 */
@Injectable({ providedIn: "root" })
export class VerifyVehicleModalTriggerService {
  private readonly trigger$ = new Subject<void>();

  /** Observable that emits when the RENDER_CTA element is clicked. */
  get onTrigger() {
    return this.trigger$.asObservable();
  }

  /** Call this when a RENDER_CTA element is clicked. */
  trigger(): void {
    this.trigger$.next();
  }
}
